<template>
	<div>
		<v-container id="details">
			<v-row no-gutters>
				<v-col cols="12" class="mb-2">
					<div class="text-h5 text-center">RICEVUTA FISCALE</div>
				</v-col>
				<v-col cols="6">
					<img :src="barcode" />
					<div class="text-h6 font-weight-bold" style="color: black"># {{ order.OrderID }}</div>
					<div class="help text-capitalize">
						{{
							new Date(order.created_at).toLocaleDateString('it-IT', {
								weekday: 'long',
								year: 'numeric',
								month: 'short',
								day: 'numeric',
							}) +
							' ' +
							new Date(order.created_at).toLocaleTimeString()
						}}
						- {{ order.Platform != 'store' ? order.Site : order.Platform }}
					</div>
					<div class="pt-5 pb-5">
						<v-avatar size="32px" tile>
							<img :src="getImageMarketplace(order.Platform)" :alt="order.Platform" />
						</v-avatar>
						<v-avatar size="16px" tile style="margin-left: 5px" v-if="order.ShippingAddress.Country">
							<img :src="getImageFlag(order.ShippingAddress)" :alt="order.ShippingAddress" />
						</v-avatar>
					</div>
				</v-col>
				<v-col cols="6">
					<div class="text-right">
						<v-img v-if="getSettings.logo != ''" :src="getSettings.logo" />
						<strong>{{ getSettings.name }}</strong
						><br />
						{{ getSettings.InvoiceAddress.Company }}<br />
						{{ getSettings.InvoiceAddress.Address }}<br />
						{{ getSettings.InvoiceAddress.City }}, {{ getSettings.InvoiceAddress.Cap }} - {{ getSettings.InvoiceAddress.Country }}<br />
						VAT: {{ getSettings.InvoiceAddress.Vat }}<br />
						<template v-if="getSettings.InvoiceAddress.Vat != getSettings.InvoiceAddress.Fiscalcode">CF: {{ getSettings.InvoiceAddress.Fiscalcode }} <br /></template>
						<span>{{ getSettings.ShippingAddress.Phone }}</span>
					</div>
				</v-col>
			</v-row>

			<v-row no-gutters class="pt-5">
				<v-col cols="12" class="mb-5">
					<div class="help">Dati cliente</div>
					<template v-if="order.buyer.name != '' || order.buyer.lastname != ''">
						<div class="text-h6 font-weight-bold text-uppercase" style="color: black">{{ order.buyer.name }} {{ order.buyer.lastname }}</div>
					</template>
					<template v-else>
						<div class="text-h6 font-weight-bold" style="color: black">N.D.</div>
					</template>
					<div class="help" style="font-size: 12px">{{ order.buyer.email }}</div>
				</v-col>
				<v-col cols="6">
					<div class="mt-2 font-weight-black">Dati Spedizione</div>
					<div class="">
						{{ order.ShippingAddress.Name }} - {{ order.ShippingAddress.Street1 }} - {{ order.ShippingAddress.CityName }} {{ order.ShippingAddress.PostalCode }} ({{
							order.ShippingAddress.StateOrProvince
						}}) - {{ order.ShippingAddress.Country }} - Tel: {{ order.ShippingAddress.Phone }}
					</div>
				</v-col>
				<v-col cols="6">
					<div class="mt-2 font-weight-black">Dati di fatturazione</div>
					<div class="">
						{{ order.InvoiceAddress && order.InvoiceAddress.Company ? 'Azienda: ' + order.InvoiceAddress.Company + ' - ' : '' }}
						<template v-if="order.InvoiceAddress.Address != ''">
							{{ order.InvoiceAddress.Address }} - {{ order.InvoiceAddress.City }} {{ order.InvoiceAddress.Cap }} ({{ order.InvoiceAddress.Province }}) - {{ order.InvoiceAddress.Country }} <br />
						</template>
						<template v-if="order.InvoiceAddress.Vat">
							Vat: {{ order.InvoiceAddress.Vat }} - Fis. Code: {{ order.InvoiceAddress.FiscalCode }} - SDI: {{ order.InvoiceAddress.Sdi }} - Pec: {{ order.InvoiceAddress.Pec }} <br />
						</template>
						Pagamento: {{ order.Checkout.StatusPayment.value }} {{ order.PaidTime ? '- Data Pagamento: ' + new Date(order.PaidTime).toLocaleString() : '' }}
					</div>
				</v-col>
			</v-row>

			<v-row no-gutters class="pt-5">
				<v-col cols="12">
					<v-divider></v-divider>
					<template>
						<v-simple-table>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">Codice</th>
										<th class="text-left" width="58%">Prodotto</th>
										<th class="text-left">Qtà</th>
										<th class="text-left">Totale</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="item in order.Items" :key="item._id">
										<td>{{ item.SKU }}</td>
										<td>{{ item.Title }}</td>
										<td>{{ item.QuantityPurchased }}</td>
										<td>{{ (+item.TransactionPrice).toFixed(2) }} {{ orderCurrency }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</template>
					<v-divider></v-divider>
				</v-col>
			</v-row>

			<v-row no-gutters class="pt-5">
				<v-col cols="9">
					<p>Note: {{ order.Message }}</p>
					<template v-if="order.ShippingService.ShippingService !== 'N.D.'">
						<p>Metodo di Spedizione: {{ order.ShippingService.ShippingService }}</p>
					</template>
					<template v-if="order.preview_courier">
						<p>Corriere: {{ order.preview_courier }}</p>
					</template>
				</v-col>
				<v-col cols="3">
					<div style="text-align: right; font-size: 14px">
						<p>
							Subtotale: {{ totals.subtotal.toFixed(2) }} {{ orderCurrency }} <br />
							<span v-if="totals.tax > 0">Tasse: {{ totals.tax.toFixed(2) }} {{ orderCurrency }} <br /></span>
							Prodotti: {{ totals.products.toFixed(2) }} {{ orderCurrency }} <br />
							<span v-if="order.ShippingService.ShippingServiceCost > 0">Spedizione: {{ (+order.ShippingService.ShippingServiceCost).toFixed(2) }} {{ orderCurrency }} <br /></span>
							<span v-if="order.CartPaymentFee && order.CartPaymentFee > 0">Fee Metodo di Pagamento: {{ (+order.CartPaymentFee).toFixed(2) }} {{ orderCurrency }}</span>
						</p>
						<p style="color: black">
							<strong>Totale: {{ order.Total.toFixed(2) }} {{ orderCurrency }}</strong>
						</p>
					</div>
				</v-col>
				<v-col offset="1" />
			</v-row>
		</v-container>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
	name: 'PrintReceipt',
	data() {
		return {
			barcode: '',
			order: {},
			totals: {
				products: 0.0,
				subtotal: 0.0,
				tax: 0.0,
			},
		};
	},
	async created() {
		document.querySelector('#app > div.v-application--wrap > header').style.display = 'none';
		var fetchItem = await this.editItem(this.$route.params);
		this.order = JSON.parse(JSON.stringify(fetchItem.result));
		this.barcode = await this.createBarcodeOrder(this.order);
		for (let prod of this.order.Items) {
			this.totals.products += +prod.TransactionPrice;
			let price_without_tax = _.round((100 * +prod.TransactionPrice) / (100 + +prod.Vat), 2);
			let price_tax = _.round(+prod.TransactionPrice - price_without_tax, 2);
			this.totals.subtotal += price_without_tax;
			this.totals.tax += price_tax;
		}
		await this.print();
	},

	computed: {
		...mapGetters({
			getSettings: 'settings/getSetting',
			getProfile: 'profile/getId',
		}),
		orderCurrency() {
			const order = this.order || {};
			if (order.Currency) return order.Currency;
			if (order.exchange) return order.exchange;
			return '€';
		},
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			editItem: 'orders/edit',
			getProfile: 'profile/getProfile',
			createBarcodeOrder: 'barcode/createBarcodeOrder',
		}),
		getImageMarketplace(img) {
			let logo = '';
			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img.Country}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},

		async print() {
			setTimeout(() => {
				window.print();
			}, 1500);
		},
	},
};
</script>

<style scoped></style>